import styled from "styled-components";
import { Layout } from "antd";

export const PageLayout = styled(Layout)`
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
`;